import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { SERVER } from 'skrit-web-framework/constantes';
import { SearchMenuContainer } from 'skrit-web-framework/containers';
import NotFound from 'skrit-web-framework/components/NotFound';
import Spinner from 'skrit-web-framework/components/Spinner';
import { setLanguage } from 'skrit-web-framework/translator';
import { setConfig } from 'skrit-web-framework';

import { routes, RouteWithSubRoutes } from '../rutas/Routes';
import Login from '../ventanas/login/login';
import Sidebar from './sidebar/Sidebar';
import store from '../store';

setConfig({ store, getLocales: lang => import(`../locales/${lang}.json`) });

const mapStateToProps = state => {
    return {
        config: state.config
    };
};

class App extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (localStorage.getItem('isLogged') === 'true') {
            let data = { method: 'PUT', credentials: 'include' };
            fetch(SERVER + '/Login/EnSession', data)
                .then(res => res.json())
                .then(json => {
                    if (json.ok) {
                        let data = {
                            ...json,
                            isLogged: true
                        };
                        store.dispatch({ type: 'SET_CONFIG', config: data });
                    } else {
                        store.dispatch({ type: 'CLEAN_STATE' });
                        localStorage.setItem('isLogged', 'false');
                        this.forceUpdate();
                    }
                });
        }
    }

    componentDidUpdate(prevProps) {
        const { theme, language } = this.props.config;
        if (prevProps.config.theme !== theme) {
            this.loadTheme(theme);
        }
        if (prevProps.config.language !== language) {
            setLanguage(language);
        }
    }

    loadTheme(theme) {
        if (theme != null && theme.Colores != null) {
            theme.Colores.map(e => {
                document.documentElement.style.setProperty(
                    `--${e.TEMC_KEY}`,
                    e.TEMC_VALUE
                );
            });
        }
    }

    render() {
        return (
            <Router>
                <div className='App-container'>
                    <SearchMenuContainer />
                    <Sidebar />
                    <Suspense fallback={<Spinner fullwindow />}>
                        <Switch>
                            <Route exact path='/login' component={Login} />
                            <Route
                                exact
                                path='/login/:user/:pwd'
                                component={Login}
                            />
                        </Switch>
                        <Route exact path='/404' component={NotFound} />
                        {routes.map((route, i) => (
                            <RouteWithSubRoutes key={i} {...route} />
                        ))}
                    </Suspense>
                </div>
            </Router>
        );
    }
}

export default connect(mapStateToProps, null)(App);
